import { createTheme } from '@mui/material/styles';
import blue from '@mui/material/colors/blue';

const theme = createTheme({
   	palette: { primary: blue },
});

export default theme;
